import React from 'react';

import cn from 'classnames';

import { Icon, UiButton, UiText } from '@shared/ui';

import cls from './MyTeamFallback.module.css';

export const MyTeamFallback = () => (
    <div className={cn(cls.MyTeamFallback)}>
        <Icon iconName="fallbackError" />
        <div className={cls.content}>
            <UiText
                tag="h2"
                variant="subHeading"
                classes={cls.colorTertiary}
                weight="bold"
                align="center"
            >
                Что-то пошло не так при загрузке
            </UiText>
            <UiText classes={cls.colorTertiary} align="center">
                Вы можете попробовать обновить страницу целиком или нажать кнопку «Обновить»
            </UiText>
        </div>
        <UiButton btnText="Обновить" onClick={() => window.location.reload()} />
    </div>
);
